<template>
  <div>
    <!-- <v-btn
      class="ml-1"
      icon
      color="#8a0000"
      x-small
      title="Saída Internação"
      @click="emitirSaida({ item: item })"
    >
      <v-icon>mdi-backspace-reverse</v-icon>
    </v-btn> -->
    <div class="p-lg-3">
      <div class="row justify-content-between ">
        <h3 class="mt-0 mb-2 font-weight-bold text-left">Óbitos</h3>
        <v-row align="center" class="d-flex my-3">
          <v-col class="d-flex col-3">
            <v-select
              :items="unidades"
              label="Unidade"
              item-value="id"
              v-model="unidadeSelected"
            ></v-select>
          </v-col>
          <v-col class="d-flex col-3">
            <v-menu
              ref="menu"
              v-model="menu"
              :close-on-content-click="false"
              :return-value.sync="datas"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="computedFormatDate"
                  label="Data inicial - Data final"
                  prepend-icon="mdi-calendar"
                  clearable
                  v-bind="attrs"
                  v-on="on"
                  @click:clear="datas = null"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="datas"
                no-title
                range
                scrollable
                color="green darken-4"
              >
                <v-spacer></v-spacer>
                <v-btn text @click="menu = false"> Cancelar</v-btn>
                <v-btn dark color="success" @click="$refs.menu.save(datas)">
                  OK
                </v-btn>
              </v-date-picker>
            </v-menu>
          </v-col>
          <v-col class="d-flex col-3">
            <v-select
                :disabled="disabled"
              :items="procedimentoList"
              item-text="descricao"
              item-value="id"
              label="Tipo de óbito"
              v-model="procedimentoId"
            ></v-select>
          </v-col>
          <v-col class="d-flex col-3" style="padding-bottom: 1rem;">
            <v-btn color="#3E682A" dark @click="ObitoListagem">
              {{ obitos_text }}
            </v-btn>
          </v-col>
        </v-row>
      </div>
    </div>
    <v-data-table
      v-on:update:sort-by="options.ordenacao = true"
      :footer-props="{ 'items-per-page-options': [5, 10, 15, 20] }"
      :headers="headers"
      :items="obitosList"
      :options.sync="options"
      :server-items-length="totalList"
      class="elevation-1"
      :loading="loading"
      :loading-text="'Carregando...'"
    >
      <template v-slot:item.data_do_obito="{ item }">
        {{ transformData(item.data_do_obito, item.hora_do_obito) }}
      </template>
      <template v-slot:item.actions="{ item }">
        <v-btn
          class="ml-1"
          icon
          color="#8a0000"
          x-small
          title="Saída Internação"
          @click="emitirSaida(item)"
        >
          <v-icon>mdi-backspace-reverse</v-icon>
        </v-btn>
      </template>
    </v-data-table>
    <v-dialog
      v-model="modalDeleteObito"
      width="700"
      transition="dialog-bottom-transition"
    >
      <modal-delete-obito
        v-if="modalDeleteObito"
        :infoObito="infoObito"
        @close="modalDeleteObito = false"
        @concluido="responseDelete()"
      ></modal-delete-obito>
    </v-dialog>
  </div>
</template>

<script>
import ObitoService from "@/services/obito_service.js";
import ModalDeleteObito from "@/components/RequisitarObito/deletar_obito.vue";
import UnidadeService from "@/services/unidade_service";
import Mixin from "@/mixins/vuex_mixin";
export default {
  mixins: [Mixin],
  components: {
    ModalDeleteObito,
  },
  data: () => ({
    datas: null,
    menu: false,
    obitos_text: "Procurar óbitos",
    perfil: "",
    direction: "bottom",
    left: false,
    hover: false,
    fab: false,
    disabled: true,
    unidades: [],
    unidadeSelected: "",
    procedimentoList: [],
    procedimentoId: 0,
    loading: false,
    totalList: 1,
    options: {
      page: 1,
      pageCount: 0,
      itemsPerPage: 15,
      ordenacao: false,
      desc: false,
    },
    headers: [
      { text: "Pet", value: "nome_pet", sortable: false },
      { text: "Tutor", value: "nome_tutor", sortable: false },
      {text: "Tipo", value: "Tipo_de_Óbito", sortable: false},
      { text: "Executor", value: "nome_executor", sortable: false },
      { text: "Data/Hora", value: "data_do_obito", sortable: false },
      {
        text: "",
        align: "end",
        value: "actions",
        sortable: false,
      },
    ],
    services: {
      obitoService: ObitoService.build(),
      unidadeService: UnidadeService.build(),
    },
    perfilId: JSON.parse(sessionStorage.getItem("vuex")).perfil.id,
    obitosList: [],
    infoObito: {},
    modalDeleteObito: false,
    unidadeId: 0,
  }),

  computed: {
    computedFormatDate() {
      const datasFormatadas =
        this.datas &&
        this.datas.map((item) =>
          item
            .split("-")
            .reverse()
            .join("/")
        );
      return datasFormatadas;
    },
  },

  watch: {
    options: {
      handler() {
        this.options.desc = this.options.sortDesc[0] ?? false;
        // this.getInternacao();
      },
      deep: true,
    },
    unidadeSelected(){
      this.setObitoList();
      this.disabled = false;
    }
    // search(value, oldValue) {
    //   if (value.length > 2) {
    //     this.options.page = 1;
    //     this.atualizarListaAssistentes();
    //   }
    //   if (value.length === 0 && oldValue.length > 0) {
    //     this.options.page = 1;
    //     this.atualizarListaAssistentes();
    //   }
    // },
  },

  async beforeMount() {
    this.perfil = JSON.parse(sessionStorage.vuex).perfil.id;
    if (this.perfil === 6) {
      this.procedimentoList = [{ descricao: "Todos", id: 0 }];
      this.procedimentoId = this.procedimentoList[0].id;
    }
    this.unidadeId = await JSON.parse(sessionStorage.getItem("vuex")).unidade
      .id;
    this.setUnidades();
  },
  async mounted() {
    this.unidadeId = await JSON.parse(sessionStorage.getItem("vuex")).unidade
      .id;
  },

  methods: {
    setObitoList(){
            this.procedimentoList = []
      this.services.obitoService
          .procedimentosObitoUnidade(this.unidadeSelected)
          .then((response) => {
            return response.json();
          })
          .then((response) => {
            let list = [
              {
                descricao: "Todos",
                id: 0,
              }
            ]
            for (let index = 0; index < response.data[0].length; index++) {
              list.push(
                  {
                    descricao: response.data[0][index].procedimento,
                    id: response.data[0][index].id_procedimento
                  })
            }
            this.procedimentoList = list;
          });
    },
    setUnidades() {
      this.services.unidadeService
        .getUnidadeByUsuarioLogado()
        .then((response) => {
          return response.json();
        })
        .then((response) => {
          this.unidades = response.data.map((unidade) => {
            return { text: unidade.unidade, id: unidade.id_unidade };
          });
        });
    },

    emitirSaida(item) {
      this.infoObito = item;
      this.modalDeleteObito = true;
    },
    transformData(data_obito, hora_obito = null) {
      let dataArr = data_obito
        .split("-")
        .reverse()
        .join("/");
      if (hora_obito) {
        let horaArr = hora_obito.split(":");
        return `${dataArr} ${horaArr[0]}:${horaArr[1]}`;
      }
      return `${dataArr}`;
    },
    responseDelete() {
      this.ObitoListagem();
      this.infoObito = {};
      this.modalDeleteObito = false;
    },
    ObitoListagem() {
      this.loading = true;

      const dataInicial = this.datas ? this.datas[0].split("-").join("") : "";
      const dataFinal = this.datas ? this.datas[1].split("-").join("") : "";
      const unidade = this.unidadeSelected ? this.unidadeSelected : "";
      const id_procedimento = this.procedimentoId;

      if (!dataInicial || !dataFinal || !unidade) {
        this.$_ACTIONS_showSnackbarMessage({
          message: "Preencha os campos corretamente",
          color: "error",
        });
        this.loading = false;
        return;
      }
      this.obitosList = [];
      this.totalList = 0;
      this.services.obitoService
        .ObitoListagem(dataInicial, dataFinal, unidade, id_procedimento)
        .then(async (resp) => {
          console.log("resp", resp);
          console.log("status", resp.status);
          if (resp.status == 200) {
            const data = await resp.json();
            console.log(data);
            let list = [];
            console.log("data", data.data.dados);
            if (data && data.data.dados) {
              for (let index = 0; index < data.data.dados.length; index++) {
                const element = data.data.dados[index];
                list.push(element);
              }
              this.obitosList = list;
              this.obitos_text = "Atualizar lista";
              this.totalList = data.data.paginacao.num_rows;
            }
          }
        })
        .catch((error) => {
          this.$_ACTIONS_showSnackbarMessage({
            message: "Falha ao carregar",
            color: "error",
          });
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
